import { isMobileOnly } from 'react-device-detect';

import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      color: colors.white,
      cursor: 'pointer',
    },
    iconContainer: {
      display: 'flex',
      padding: '8px 8px 8px 0',
      flexShrink: 0,
      '& svg': {
        width: isMobileOnly ? 26 : 32,
        height: isMobileOnly ? 26 : 32,
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '4px',
    },
    name: {
      fontWeight: 600,
      fontSize: isMobileOnly ? 12 : 16,
      lineHeight: '16px',
      color: colors.white,
    },
    description: {
      fontWeight: 500,
      fontSize: 12,
      lineHeight: '16px',
      color: colors.grey,
    },
  };
};
